import {
  updateChannelUrlParams,
  buriedCapital,
  codeRegister,
  getChannelDetail,
  ifUserCapital,
  onlineLoanProductMatch,
  pointTrigger,
  baseUserInfo,
} from '@/api/login';
import { verifyPhoneNumber } from '@/utils/validate';
import { Toast } from 'vant';
import { storage } from '@/utils/storage';
import { isIos, baseDayTimeMethod, toBase62 } from '@/utils/common';
import { pageJump } from './useJump';
import { useMyRegister } from '@/store/modules/register';
import { IObjStr } from '@/utils/http';
import { buriedPoint } from '@/utils/config';
import { pageInitRequest } from '@/hooks/useInitBasic';
import { clueOnlineLoanProductMatch } from '@/api/pageLoading';
const { buriedPointFn } = pageInitRequest();

export function loginRegister() {
  const urlParams = window.location.search ? window.location.search.substring(1) : '';
  // console.log(urlParams, 'urlParams====');
  const pageJump_ = pageJump();
  /** 验证码和手机号注册
   * callback： 回调函数
   * isTokenLogin： token登录， tokenLogin方法使用
   * loginPhone： 手机号
   * loginCode： 验证码
   * guestUserInfoAuthState： 当前该流程配置的main.ts tokenLogin方法使用
   * isGoResult: 是否优速融嵌入钱包页面
   * */
  async function submitInfo(
    loginPhone: string,
    loginCode: string
  ): Promise<boolean | string | undefined> {
    // 点击下载/注册日志记录
    if (!verifyPhoneNumber(loginPhone)) return false;
    if (!loginCode) {
      Toast('请输入验证码');
      return false;
    }
    const loginData: IObjStr = { userPhone: loginPhone, code: loginCode };
    const userUUid = storage.getItem('userUUid', 2);
    if (userUUid) {
      loginData.uuid = userUUid;
    }
    let result;
    try {
      result = await codeRegister(loginData);
      if (result.token) {
        storage.setItem('token', result.token);
        storage.setItem('xdToken', result.token);
      }
      storage.setItem('phone', loginPhone);
    } catch (e) {
      return 'err';
    }
    await buriedCapital({ point: buriedPoint.TYPE_login });
    if (result && result.token) {
      return true;
    } else {
      return 'err';
    }
  }
  /**显示页面配置产品组件*/
  const pageShow = ref<boolean>(false);
  const router = useRouter();
  /**
   * isTokenLogin: 是否token登录
   * isGoResult： 当前页是否前往优速融结果页
   * */
  async function tokenLogin(isTokenLogin: boolean, isGoResult = false) {
    if (isTokenLogin) {
      buriedCapital({ point: buriedPoint.TYPE_token_login }).then();
      /**渠道埋点*/
      pointTrigger({ point: buriedPoint.TYPE_TOKEN_LOGIN }).then();
      // 上传路由？全参数
      await updateChannelUrlParams({
        reportData: JSON.stringify({ urlParams: urlParams + '&host=' + window.location.host }),
      });
      /** 获取user_id 存本地 */
      const userInfo = await baseUserInfo();
      const userId = toBase62(Number(userInfo.userId));
      storage.setItem('userId', userId, null, 2);
      /** 虚拟用户：统一跳转162普通网贷，阻断普通信贷流程 */
      const virtualUserFlag = String(userInfo?.virtualUser);
      const isVirtualUser = virtualUserFlag === 'true' || virtualUserFlag === '1';
      if (isVirtualUser) {
        storage.setItem('virtualUser', true, null, 2);
        storage.removeItem('resultList', 2);
        storage.removeItem('applicationSuccess', 2);
        await router.replace({
          path: '/IFPageOneHSixtyTwoLoading',
          query: {
            sourcePage: 'virtualTokenRedirect',
          },
        });
        return 'virtual';
      }
    }
    /**登录后，若登录页的贷款金额＜2万，则直接跳转动画页，3秒后，自动跳转下载页 申候伟说的全干掉*/
    /*if (
      storage.getItem('loginLoanMoney', 2) &&
      Number(storage.getItem('loginLoanMoney', 2)) < 20000
    ) {
      pageJump_.jump();
      return;
    }*/
    /**接口查询 审核环境 没有留资和匹配产品的逻辑、当前城市没有在线的信贷产品或者渠道设置当前城市不准入 用户登录后直接跳转动画页，3秒后，自动跳转下载页；*/
    /**没有留资和匹配产品的逻辑  注册下载页*/
    const channelInfo = await getChannelDetail({
      channelId: storage.getItem('channelId', 2) || '',
    });
    /**审核环境 0:否 1:是**/
    if (channelInfo && channelInfo.ifChecking == 1) {
      return 'jump';
    }
    /**当前定位城市**/
    const localCity = <string>storage.getItem('localCity', 2);
    /**渠道设置当前城市不准入**/
    if (channelInfo && channelInfo.cityEnable && channelInfo.city) {
      const cityEnable = channelInfo.cityEnable;
      const city = (<string>channelInfo.city).split(',');
      const cityObj = city.find((list) => list === localCity);
      if ((cityEnable == 1 && !cityObj) || (cityEnable == 2 && cityObj)) {
        return 'jump';
      }
    }
    let res;
    try {
      res = await ifUserCapital();
    } catch (e) {
      return 'err';
    }
    if (res) {
      storage.setItem('getUserInfo', res, null, 2);
      if (!res.hasOnlineProduct) {
        buriedPointFn(true, [
          {
            currentPageCode: 'ysr100001',
            currentPageName: '访问页',
            fromPageCode: '',
            fromPageName: '',
            fromUrl: '',
            logTime: baseDayTimeMethod.getDateTime(),
            eventCode: 'JR_H5_NORNAL_CITY_MODE',
            extraDataJson: {
              normalCity: storage.getItem('cityChoose', 2),
              isProduct: 0,
            },
          },
        ]);
        // 当用户所在城市无信贷产品时, 推荐网贷产品
        return 'online';
      } else {
        buriedPointFn(true, [
          {
            currentPageCode: 'ysr100001',
            currentPageName: '访问页',
            fromPageCode: '',
            fromPageName: '',
            fromUrl: '',
            logTime: baseDayTimeMethod.getDateTime(),
            eventCode: 'JR_H5_NORNAL_CITY_MODE',
            extraDataJson: {
              normalCity: storage.getItem('cityChoose', 2),
              isProduct: 1,
            },
          },
        ]);
      }
      /**是否留资**/
      if (res.hasCapital) {
        buriedPointFn(true, [
          {
            currentPageCode: 'ysr100001',
            currentPageName: '访问页',
            fromPageCode: '',
            fromPageName: '',
            fromUrl: '',
            logTime: baseDayTimeMethod.getDateTime(),
            eventCode: 'JR_H5_IS_INFORMATION_MODE',
            extraDataJson: {
              isInformation: 0,
            },
          },
        ]);
        /** 根据页面标识，判断 跳转钱包 or 前往结果页 **/
        return 'loading';
      } else {
        buriedPointFn(true, [
          {
            currentPageCode: 'ysr100001',
            currentPageName: '访问页',
            fromPageCode: '',
            fromPageName: '',
            fromUrl: '',
            logTime: baseDayTimeMethod.getDateTime(),
            eventCode: 'JR_H5_IS_INFORMATION_MODE',
            extraDataJson: {
              isInformation: 1,
            },
          },
        ]);
        return 'leaveInfo';
      }
    } else {
      return 'jump';
    }
    return 'err';
  }
  /**页面跳转方法
   * guestUserInfoAuthState： 当前该流程配置的main.ts
   * name： 跳转关键字
   * */
  function goPageFn(name: string, guestUserInfoAuthState: IObjStr) {
    switch (name) {
      case 'virtual':
        // tokenLogin 已 replace 到162，禁止走 default 的 jump
        break;
      case 'jump':
        pageJump_.jump();
        break;
      case 'leaveInfo':
        router.push({
          path: <string>guestUserInfoAuthState['0'],
        });
        break;
      case 'loading':
        router.push({
          path: <string>guestUserInfoAuthState.loading,
          query: {
            sourcePage: 'h5注册',
          },
        });
        break;
      default:
        pageJump_.jump();
    }
  }
  /**显示网贷页面*/
  const onlineData = reactive({
    show: false,
    data: {},
  });
  const onlineGoPage = () => {
    onlineData.show = false;
  };
  /**获取网贷*/
  async function getOnline() {
    let res;
    try {
      res = await onlineLoanProductMatch();
    } catch (e) {
      return false;
    }
    if (res && res.length) {
      const item = res[0];
      if (item.label) {
        item.labelList = item.label.split(',');
      } else {
        item.labelList = [];
      }
      onlineData.data = item;
      onlineData.show = true;
      return true;
    } else {
      return false;
    }
  }
  /**获取易鑫车主贷*/
  const getYxCarData = async () => {
    let res;
    try {
      res = await clueOnlineLoanProductMatch();
    } catch (e) {
      return false;
    }
    if (res && res.length) {
      const item = res[0];
      storage.setItem('carInfo', item, null, 2);
      return true;
    } else {
      return false;
    }
  };
  /** 从后台获取渠道详细guide下载页数据,动态guide页
   * */
  const getChannelDetailFn = () => {
    storage.removeItem('guideFromBackground', 2);
    getChannelDetail({ channelId: storage.getItem('channelId', 2) || '' }).then((res) => {
      if (res) {
        if (!isIos()) {
          let downloadUrl: string | undefined = '';
          if (res.androidGuideStatus === 1 && res.androidGuidePageContent) {
            let temp = {
              template: '',
            };
            try {
              temp = JSON.parse(<string>res.androidGuidePageContent);
              downloadUrl = temp.template;
              // eslint-disable-next-line no-empty
            } catch (e) {}
          } else {
            downloadUrl =
              <string>res.androidChannelRegisterPage &&
              (<IObjStr>res.androidChannelRegisterPage).downloadUrl;
          }
          if (downloadUrl) {
            storage.setItem('guideFromBackground', downloadUrl, null, 2);
          }
        } else {
          let downloadUrl: string | undefined = '';
          if (res.iosGuideStatus === 1 && res.iosGuidePageContent) {
            let temp = {
              template: '',
            };
            try {
              temp = JSON.parse(<string>res.iosGuidePageContent);
              downloadUrl = temp.template;
              // eslint-disable-next-line no-empty
            } catch (e) {}
          } else {
            downloadUrl =
              <string>res.iosChannelRegisterPage &&
              (<IObjStr>res.iosChannelRegisterPage).downloadUrl;
          }
          if (downloadUrl) {
            storage.setItem('guideFromBackground', downloadUrl, null, 2);
          }
        }
        storage.setItem('channelIdInfo', res, null, 2);
        const { changeChannelInfo } = useMyRegister();
        changeChannelInfo(res);
      }
    });
  };

  return {
    pageShow,
    onlineData,
    submitInfo,
    goPageFn,
    getOnline,
    onlineGoPage,
    getYxCarData,
    tokenLogin,
    getChannelDetailFn,
  };
}
